document.addEventListener("DOMContentLoaded", function() {
    const modal = document.getElementById("team-modal");
    const closeModal = document.querySelector(".team-modal .modal-close");
    const modalTabLink = document.querySelectorAll(".modal-tab_link");

    document.querySelectorAll(".team-person-wrapper").forEach(person => {
        person.addEventListener("click", function() {
            const color = this.getAttribute('data-color');
            const personalData = JSON.parse(this.getAttribute("data-personal-data"));
            const vita = JSON.parse(this.getAttribute("data-vita"));
            const trainings = JSON.parse(this.getAttribute("data-trainings"));
            const publications = JSON.parse(this.getAttribute("data-publications"));
            const translations = JSON.parse(this.getAttribute("data-translations"));

            var tabNumber = 0; // count the number of tabs
            if (vita && vita.career_path && vita.career_path.length > 0) {
                tabNumber++;
            }
            if (trainings && trainings.training && trainings.training.length > 0) {
                tabNumber++;
            }
            if (publications && publications.publication && publications.publication.length > 0) {
                tabNumber++;
            }

            // Set the color of the close icon
            const closeIconPath = document.querySelector('.team-modal .modal-close svg path');
            if (closeIconPath) {
                closeIconPath.setAttribute('fill', color);
            }

            // Select the modal body
            const modalBody = document.querySelector(".modal-body");
            modalBody.innerHTML = '';

            // Create the modal wrapper
            const modalWrapper = document.createElement('div');
            modalWrapper.className = 'team-modal-wrapper d-flex has-background-turquoise-10';

            // Create the image part
            const imageDiv = document.createElement('div');
            imageDiv.className = 'team-modal-wrapper_image';
            imageDiv.innerHTML = `<img src="${personalData.image.url}" alt="${personalData.image.alt}" title="${personalData.image.title}" />`;
            modalWrapper.appendChild(imageDiv);

            // Create the info part
            const infoDiv = document.createElement('div');
            infoDiv.className = 'team-modal-wrapper_infos position-relative';

            const plusIconRed = document.createElement('div');
            plusIconRed.className = 'bg-icon-plus red';
            plusIconRed.innerHTML = iconPlusSvg;
            infoDiv.appendChild(plusIconRed);

            const plusIconBlueLight = document.createElement('div');
            plusIconBlueLight.className = 'bg-icon-plus blue-light';
            plusIconBlueLight.innerHTML = iconPlusSvg;
            infoDiv.appendChild(plusIconBlueLight);


            const firstNameP = document.createElement('p');
            firstNameP.className = 'team-modal-wrapper_infos-firstname';
            firstNameP.textContent = personalData.firstname;
            infoDiv.appendChild(firstNameP);

            const lastNameP = document.createElement('p');
            lastNameP.className = 'team-modal-wrapper_infos-lastname';
            lastNameP.textContent = personalData.lastname;
            infoDiv.appendChild(lastNameP);

            const positionP = document.createElement('p');
            positionP.className = 'team-modal-wrapper_infos-position mt-4 mt-sm-3';
            positionP.textContent = personalData.position;
            infoDiv.appendChild(positionP);

            const introP = document.createElement('p');
            introP.className = 'team-modal-wrapper_infos-introduction mt-5';
            introP.textContent = personalData.introduction;
            infoDiv.appendChild(introP);

            if (personalData.button && personalData.button.title) {
                const button = document.createElement('a');
                button.className = 'team-modal-wrapper_infos-button btn btn-primary d-flex mt-5';
                button.href = personalData.button.url;
                button.target = personalData.button.target;
                button.innerHTML = `
                    ${personalData.button.title}
                    <div class="icon-plus">${document.querySelector('.icon-plus').innerHTML}</div>
                `;
                infoDiv.appendChild(button);
            }

            modalWrapper.appendChild(infoDiv);
            modalBody.appendChild(modalWrapper);

            // Create the modal data (tabs and contents)
            const modalData = document.createElement('div');
            modalData.className = 'modal-data';

            // Create the tabs
            const modalTabs = document.createElement('div');
            modalTabs.className = 'modal-tabs nav-tabs d-flex align-items-center';

            // Create the contents
            const tabContents = document.createElement('div');

            // Add the tabs and contents if they exist
            if (vita && vita.career_path && vita.career_path.length > 0) {
                // Tab Vita
                const vitaTab = document.createElement('a');
                vitaTab.className = `modal-tab_link tab-link has-${tabNumber}-tabs active d-flex align-items-center justify-content-top justify-content-sm-center`;
                vitaTab.setAttribute('data-tab', 'vita');
                vitaTab.innerHTML = `
                    ${translations.vita}
                    <div class="icon-plus">${document.querySelector('.icon-plus').innerHTML}</div>
                `;
                modalTabs.appendChild(vitaTab);

                // Vita Content
                const vitaContent = document.createElement('div');
                vitaContent.id = 'vita';
                vitaContent.className = 'tab-content active';
                vitaContent.innerHTML = vita.career_path.map(section => `
                    <h3 class='d-none d-md-block my-5 pl-5'>${section.title}</h3>
        
                    ${section.activity.map(act => `
                        <div class="tab-content_row d-flex has-background-turquoise-10 p-5 my-3">
                            <div class="tab-content_row_company order-2 order-md-1 mb-2 mb-md-0">${act.company}</div>
                            <div class="tab-content_row_description order-1 order-md-2 mb-4 mb-md-0">${act.description}</div>
                            <div class="tab-content_row_period order-3">${act.period}</div>
                        </div>`).join('')}
                    
                `).join('');
                tabContents.appendChild(vitaContent);
            }

            if (trainings && trainings.training && trainings.training.length > 0) {
                // Tab Trainings
                const trainingsTab = document.createElement('a');
                trainingsTab.className = `modal-tab_link tab-link has-${tabNumber}-tabs d-flex align-items-center justify-content-top justify-content-sm-center`;
                trainingsTab.setAttribute('data-tab', 'trainings');
                trainingsTab.innerHTML = `
                    ${translations.trainings}
                    <div class="icon-plus">${document.querySelector('.icon-plus').innerHTML}</div>
                `;
                modalTabs.appendChild(trainingsTab);

                // Trainings content
                const trainingsContent = document.createElement('div');
                trainingsContent.id = 'trainings';
                trainingsContent.className = 'tab-content';
                if (vita && vita.career_path && vita.career_path.length > 0) {
                    trainingsContent.classList.remove('active');
                } else {
                    trainingsTab.classList.add('active');
                    trainingsContent.classList.add('active');
                }
                trainingsContent.innerHTML = trainings.training.map(train => `
                    <div class="tab-content_row d-flex has-background-turquoise-10 p-5 my-3">
                        <div class="tab-content_row_company order-2 order-md-1 mb-2 mb-md-0">${train.institution}</div>
                        <div class="tab-content_row_description order-1 order-md-2 mb-4 mb-md-0">${train.description}</div>
                        <div class="tab-content_row_period order-3">${train.year}</div>
                    </div>
                `).join('');
                tabContents.appendChild(trainingsContent);
            }

            if (publications && publications.publication && publications.publication.length > 0) {;
                // Tab Publications
                const publicationsTab = document.createElement('a');
                publicationsTab.className = `modal-tab_link tab-link has-${tabNumber}-tabs d-flex align-items-center justify-content-top justify-content-sm-center`;
                publicationsTab.setAttribute('data-tab', 'publications');
                publicationsTab.innerHTML = `
                    ${translations.publications}
                    <div class="icon-plus">${document.querySelector('.icon-plus').innerHTML}</div>
                `;
                modalTabs.appendChild(publicationsTab);

                // Publications content
                const publicationsContent = document.createElement('div');
                publicationsContent.id = 'publications';
                publicationsContent.className = 'tab-content';
                if ((vita && vita.career_path && vita.career_path.length > 0) || 
                    (trainings && trainings.training && trainings.training.length > 0)) {
                    publicationsContent.classList.remove('active');
                } else {
                    publicationsTab.classList.add('active');
                    publicationsContent.classList.add('active');
                }
                publicationsContent.innerHTML = publications.publication.map(pub => `
                    <div class="tab-content_row_pub d-flex has-background-turquoise-10 p-5 my-3">
                        <div class="tab-content_row_pub_wrapper d-flex">
                            <div class="tab-content_row_pub_wrapper_title mb-4">${pub.title}</div>
                            <div class="tab-content_row_pub_wrapper_author">${pub.author}</div>
                            <div class="tab-content_row_pub_wrapper_source">${pub.source}</div>
                        </div>
                        ${pub.file ? `
                            <div class="tab-content_row_pub_download d-flex justify-content-top justify-content-md-bottom align-items-center">
                                <a class="btn btn-primary" href="${pub.file.url}" target="_blank">
                                    ${translations.download}
                                    <div class="icon-plus">${document.querySelector('.icon-plus').innerHTML}</div>
                                </a>
                            </div>
                        ` : ''}
                        ${pub.link ? `
                            <div class="tab-content_row_pub_link d-flex justify-content-top justify-content-md-bottom align-items-center">
                                <a class="btn btn-primary" href="${pub.link.url}" target="${pub.link.target}">
                                    ${pub.link.title}
                                    <div class="icon-plus">${document.querySelector('.icon-plus').innerHTML}</div>
                                </a>
                            </div>
                        ` : ''}
                    </div>
                `).join('');
                tabContents.appendChild(publicationsContent);
            }

            

            // Append the tabs and contents to the modal
            if (modalTabs.children.length > 0) {
                modalData.appendChild(modalTabs);
                modalData.appendChild(tabContents);
                modalBody.appendChild(modalData);
            }

            // Add colorful line
            const colorfulLine = document.createElement('div');
            colorfulLine.className = 'colorful-line d-flex';
            colorfulLine.innerHTML = `
                <div class="has-background-red"></div>
                <div class="has-background-yellow"></div>
                <div class="has-background-green"></div>
                <div class="has-background-violett"></div>
                <div class="has-background-blue-light"></div>
                <div class="has-background-turquoise"></div>
                <div class="has-background-blue-dark"></div>
            `;
            modalBody.appendChild(colorfulLine);

            // Open modal
            modal.style.display = "flex";
            document.body.style.overflow = "hidden";

            // Add event listeners to the tabs
            if (modalTabs.children.length > 0) {
                const newModalTabLinks = document.querySelectorAll(".modal-tab_link");
                const newTabContents = document.querySelectorAll(".tab-content");

                newModalTabLinks.forEach(link => {
                    link.addEventListener("click", function() {
                        newModalTabLinks.forEach(tab => tab.classList.remove("active"));
                        newTabContents.forEach(content => content.classList.remove("active"));
                        
                        this.classList.add("active");
                        document.getElementById(this.getAttribute("data-tab")).classList.add("active");
                    });
                });
            }
        });
    });

    // Close modal
    if (closeModal) {
        closeModal.addEventListener("click", function() {
            modal.style.display = "none";
            document.body.style.overflow = "visible";
        });
    }

    window.addEventListener("click", function(event) {
        if (event.target == modal) {
            modal.style.display = "none";
            document.body.style.overflow = "visible";
        }
    });
});